import React from "react";
import { Download, Trash2, Images, X } from "lucide-react";
import { useApp } from "../../context/AppContext";
import { Panel, Overline } from "../common/Panel";
import { toast } from "sonner";

export default function Gallery() {
  const { snapshots, deleteSnapshot, clearSnapshots } = useApp();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <Overline>Snapshot Archive</Overline>
          <h2 className="font-heading font-bold text-2xl tracking-tight mt-1">Gallery</h2>
          <p className="text-sm text-[var(--t2)] mt-1">{snapshots.length} snapshot{snapshots.length !== 1 ? "s" : ""} stored locally in your browser.</p>
        </div>
        {snapshots.length > 0 && (
          <button data-testid="gallery-clear" onClick={() => { clearSnapshots(); toast.success("Gallery cleared"); }} className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-[var(--danger)]/50 text-[var(--danger)] text-sm hover:bg-[var(--danger)]/10 transition-colors">
            <Trash2 size={15} /> Clear All
          </button>
        )}
      </div>

      {snapshots.length === 0 ? (
        <Panel className="p-16 flex flex-col items-center justify-center text-center" data-testid="gallery-empty">
          <Images size={48} className="text-[var(--t2)] opacity-40 mb-4" />
          <p className="font-heading font-bold text-lg">No snapshots saved</p>
          <p className="text-sm text-[var(--t2)] mt-1 font-mono">Capture images from the Camera tab to build your archive.</p>
        </Panel>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4" data-testid="gallery-grid">
          {snapshots.map((s) => (
            <Panel key={s.id} hover className="overflow-hidden group" data-testid="gallery-item">
              <div className="aspect-video overflow-hidden">
                <img src={s.url} alt="snap" className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
              </div>
              <div className="p-3">
                <p className="font-mono text-[11px] text-[var(--t2)]">{new Date(s.ts).toLocaleString()}</p>
                <div className="flex gap-2 mt-2">
                  <a href={s.url} download={`snapshot-${s.id}.jpg`} data-testid="gallery-download" className="flex-1 py-1.5 rounded-md bg-[var(--surface2)] border border-[var(--bd)] text-xs flex items-center justify-center gap-1 hover:border-[var(--bd-strong)] transition-colors"><Download size={13} /> Save</a>
                  <button onClick={() => deleteSnapshot(s.id)} data-testid="gallery-delete" className="py-1.5 px-3 rounded-md border border-[var(--danger)]/40 text-[var(--danger)] text-xs flex items-center justify-center hover:bg-[var(--danger)]/10 transition-colors"><X size={13} /></button>
                </div>
              </div>
            </Panel>
          ))}
        </div>
      )}
    </div>
  );
}
